import { AnimatePresence, motion } from 'motion/react'
import { useContext } from 'react'
import {
  bottomWrapper,
  sideWrapper
} from '~/components/Layout/AsideActionWrapper/AsideActionWrapper.css'
import type { AsideActionPosition } from '~/types/global'
import { AsideActionContext } from '~/utils/contextes'

export const AsideActionWrapper = ({
  position = 'sidebar'
}: {
  position?: AsideActionPosition
}) => {
  const {
    asideAction,
    isWide,
    position: contextPosition
  } = useContext(AsideActionContext)
  return (
    <AnimatePresence>
      {asideAction && contextPosition === position && (
        <motion.div
          className={position === 'bottom' ? bottomWrapper : sideWrapper}
          key="aside-action"
          initial={
            position === 'bottom'
              ? { opacity: 0, y: -10 }
              : { opacity: 0, flexBasis: '0' }
          }
          animate={
            position === 'bottom'
              ? { opacity: 1, y: 0 }
              : {
                  opacity: 1,
                  flexBasis: isWide && position !== 'modal' ? '700px' : '500px'
                }
          }
          exit={
            position === 'bottom'
              ? { opacity: 0, y: -10 }
              : { opacity: 0, flexBasis: '0' }
          }
        >
          {asideAction}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
